type LifecycleTarget = Pick<EventTarget, 'addEventListener' | 'removeEventListener'>;

/** Start pending writes while the page is still alive; browser termination can interrupt IndexedDB. */
export function bindDshSessionLifecycle(
  flush: () => Promise<void>,
  page: LifecycleTarget,
  document: LifecycleTarget & { readonly visibilityState: string },
): () => void {
  const save = () => { void flush().catch(() => undefined); };
  const visibilityChanged = () => { if (document.visibilityState === 'hidden') save(); };
  page.addEventListener('pagehide', save);
  document.addEventListener('visibilitychange', visibilityChanged);
  return () => {
    page.removeEventListener('pagehide', save);
    document.removeEventListener('visibilitychange', visibilityChanged);
  };
}
